import { Box, Divider, IconButton, Tooltip, Drawer, useTheme, styled, Typography, CircularProgress, InputLabel, OutlinedInput, Grid, Button } from "@mui/material";
import { useState, useEffect } from "react";
import { getSectionRooms, deleteRoom, handleEditRoom } from "../../../functions/restaurant";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import EditIcon from '@mui/icons-material/Edit';
import icon from '../../../images/Room_Icon.png'
import DeleteIcon from '@mui/icons-material/Delete';
import ModalLayout from "../../modals/Layout";
import { notify } from "../../Toast";

const DrawerHeader = styled('div')(({ theme }) => ({
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
}));

const RoomsDrawer = ({ onClose, open, roomID, section, serviceFees }) => {
    const theme = useTheme();
    const [rooms, setRooms] = useState([]);
    const [loading, setLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [editLoading, setEditLoading] = useState(false);
    const [deleting, setDelete] = useState(false);
    const [edit, setEdit] = useState(false);
    const [activeRoom, setActiveRoom] = useState(null);
    const [editPayload, setEditPayload] = useState({ service_charge: null, room_name: null });

    const handleGetData = () => {
        if (roomID) {
            setLoading(true);
            getSectionRooms(roomID).then(res => {
                const { data: { data } } = res;
                setRooms(data);
                setLoading(false);
            })
        }
    };

    const container = window !== undefined ? () => window.document.body : undefined;

    useEffect(() => handleGetData(), [roomID]);

    const handleDelete = () => {
        const { id } = activeRoom;
        setDeleteLoading(true);
        deleteRoom(id).then(res => {
            notify(res.data.message, "success");
            setDeleteLoading(false);
            setDelete(false);
            handleGetData();
        }).catch(err => {
            notify(err.data?.message, "error");
            setDeleteLoading(false);
            setDelete(false);
        })
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        setEditLoading(true)
        const { id } = activeRoom;
        handleEditRoom(id, editPayload).then(res => {
            notify("Room Edited successfully", "success");
            setEdit(false);
            setEditLoading(false);
            handleGetData();
        }).catch(err => {
            notify(err.data?.message, "error");
            setEdit(false);
            setEditLoading(false);
        })
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setEditPayload({ ...editPayload, [name]: value });
    };

    const inputs = [
        {
            name: "room_name",
            label: "Room Name",
            value: editPayload.room_name,
            type: "text"
        },
        {
            name: "service_charge",
            label: "Service charge",
            value: editPayload.service_charge,
            type: "number"
        }
    ]

    return (
        <>
            <Drawer
                container={container}
                anchor="right"
                variant="temporary"
                open={open}
                onClose={onClose}
                sx={{
                    // zIndex: 9991,
                    "& .MuiDrawer-paper": {
                        boxSizing: "border-box",
                        borderWidth: 0,
                        width: { xs: 350, md: 500 },
                        backgroundColor: '#FAFAFA',
                    }
                }}
            >
                <DrawerHeader>
                    <IconButton onClick={onClose}>
                        {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                    </IconButton>

                    <Typography>Section Room Details</Typography>
                </DrawerHeader>
                <Divider />

                <div className="px-8">
                    {loading ? (
                        <div className='mt-6'>
                            <div className='h-5 w-3/5 bg-gray-200 animate-pulse rounded'></div>
                            <div className='h-3 w-2/5 bg-gray-200 animate-pulse rounded mt-4'></div>
                        </div>
                    ) : (
                        <div className="mt-4">
                            <h1 className='font-bold text-xl mt-4'>{section} || <span className="font-semibold text-sm">{rooms.length} rooms</span></h1>
                        </div>
                    )}

                    <div className="mt-6">
                        {loading ?
                            Array(5).fill(0).map((el, __) => (
                                <div key={el} className='w-full flex justify-between items-center my-4 p-4 shadow bg-white'>
                                    <div className='w-4/6 flex items-center gap-3'>
                                        <div className='h-10 w-10 bg-gray-200 animate-pulse rounded'></div>
                                        <div className='w-5/6 flex flex-col gap-2'>
                                            <div className='h-4 w-3/5 bg-gray-200 animate-pulse rounded'></div>
                                            <div className='h-3 w-2/5 bg-gray-200 animate-pulse rounded'></div>
                                        </div>
                                    </div>

                                    <div className='w-2/6 flex justify-end gap-3'>
                                        <div className='h-6 w-6 bg-gray-200 animate-pulse rounded-full'></div>
                                        <div className='h-6 w-6 bg-gray-200 animate-pulse rounded-full'></div>
                                    </div>
                                </div>
                            ))

                            :

                            <div className="space-y-4">
                                {rooms.toReversed().map((room, __) => (
                                    <div key={room.id} className="flex items-center justify-between gap-2 bg-white p-4 shadow">
                                        <div className="flex items-center gap-2">
                                            <img className='h-10' src={icon} alt="" />
                                            <div>
                                                <p>{room?.room_name}</p>
                                                <p className="text-xs font-semibold">Fees: Ksh {room.service_charge}.00</p>
                                            </div>
                                        </div>
                                        <Box>
                                            <Tooltip title="Delete section room">
                                                <IconButton onClick={() => {
                                                    setEdit(true);
                                                    setActiveRoom(room);
                                                    setEditPayload({
                                                        service_charge: room.service_charge, room_name: room.room_name
                                                    });
                                                }}>
                                                    <EditIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Delete section room">
                                                <IconButton onClick={() => {
                                                    setDelete(true);
                                                    setActiveRoom(room);
                                                }}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    </div>
                                ))}
                            </div>
                        }
                    </div>
                </div>
            </Drawer>

            <ModalLayout open={deleting} setOpen={setDelete} title={`Delete Room`}>
                <div>
                    <p className="my-6">Are you sure you want to delete room?</p>
                    <div className="flex gap-4 justify-end">
                        <button onClick={() => setDelete(false)} className="bg-gray-200 px-6 py-2 rounded">Cancel</button>
                        <button disabled={deleteLoading} onClick={handleDelete} className="flex items-center gap-3 bg-red-600 px-6 py-2 text-red-100 rounded">
                            Delete {deleteLoading && (<CircularProgress color="inherit" size="1.2rem" />)}
                        </button>
                    </div>
                </div>
            </ModalLayout>

            <ModalLayout open={edit} title={"Edit Room Details"} setOpen={setEdit}>
                <form onSubmit={(e) => handleSubmit(e)}>
                    <Grid container rowGap={3} sx={{ mt: 2, width: "100%" }}>
                        {inputs.map((input, __) => (
                            <Grid xs={12} key={input.name}>
                                <InputLabel htmlFor={input.name}>{input.label}</InputLabel>
                                <OutlinedInput
                                    placeholder={input.label}
                                    id={input.name}
                                    fullWidth
                                    value={input.value}
                                    name={input.name}
                                    onChange={handleChange}
                                    type={input.type}
                                />
                            </Grid>
                        ))}
                        <Button
                            type="submit"
                            onClick={(e) => handleSubmit(e)}
                            disableElevation
                            sx={{ mt: 2, height: 55, fontSize: "1rem", color: "white" }}
                            variant="contained"
                            fullWidth
                        >
                            {editLoading ? (<CircularProgress color="inherit" size="1.5rem" />) : "Save Changes"}
                        </Button>
                    </Grid>
                </form>
            </ModalLayout>
        </>
    )
}

export default RoomsDrawer